import { render, staticRenderFns } from "./CurrencySlider.vue?vue&type=template&id=36ce4bad&scoped=true&"
import script from "./CurrencySlider.vue?vue&type=script&lang=js&"
export * from "./CurrencySlider.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySlider.vue?vue&type=style&index=0&id=36ce4bad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce4bad",
  null
  
)

export default component.exports